let Recaptcha = require('./recaptcha');

module.exports = {
  install (Vue) {
    window.recaptchaOnLoaded = function () {
      window.eventsBus.$emit('RecaptchaReadyEvent');
    };

    Vue.component('recaptcha', Recaptcha);
  }
};
